import { Validators } from '@angular/forms';
import { IColumnConfigTableResponsive } from 'src/app/domain/IColumnConfigTableResponsive';
import { ContractSignatureType } from 'src/app/domain/enums/contract-signature-type.enum';
import { FieldTypeEnum } from 'src/app/domain/registration/enums/field-type.enum';
import { TableResponsiveTypeColumnEnum } from 'src/app/domain/registration/enums/table-responsive-type-column.enum';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';

export const RELATIVE_URL = 'customers';

export const COLUMNS_TO_SHOW_WEB = [
    'select',
    'image',
    'code',
    'document',
    'name',
    'tradingName',
    'phone',
    'cellPhone',
    'email',
    'isLicenseGenerated',
    'actions',
];
export const COLUMNS_TO_SHOW_MOBILE = COLUMNS_TO_SHOW_WEB;
export const TABLE_CONFIG_COLUMNS: IColumnConfigTableResponsive[] = [
    {
        link_show: true,
        field_type: FieldTypeEnum.LABEL,
        property: 'code',
        display: 'CÓDIGO',
        class: `${TableResponsiveTypeColumnEnum.SUBTITLE}`,
    },
    {
        link_show: true,
        field_type: FieldTypeEnum.IMAGE,
        property: 'image',
        class: `${TableResponsiveTypeColumnEnum.SUBTITLE} image-size`,
    },
    {
        field_type: FieldTypeEnum.LABEL,
        link_show: true,
        property: 'document',
        display: 'CPF / CNPJ',
        class: TableResponsiveTypeColumnEnum.SUBTITLE,
    },
    {
        field_type: FieldTypeEnum.LABEL,
        link_show: true,
        property: 'name',
        display: 'Cliente',
        class: TableResponsiveTypeColumnEnum.SUBTITLE,
    },

];

export const CES_CONFIG_FIELDS = [
    // id - hidden
    {
        type: TypeComponentFieldEnum.HIDDEN,
        name: 'id',
    },
    {
        label: 'ÁTIVO',
        name: 'isActive',
        type: TypeComponentFieldEnum.SLIDE_TOGGLE,
    },
    {
        name: 'image',
        type: TypeComponentFieldEnum.IMAGE,
    },
    {
        label: 'CÓDIGO',
        name: 'code',
        type: TypeComponentFieldEnum.INPUT,
        validation: [],
    },

];

export const CONTRACT_MODAL_CONFIG = [
    {
        link_show: true,
        label: 'NOME',
        name: 'name',
        type: TypeComponentFieldEnum.INPUT,
    },
];

export const ADD_SIGNATURE_DIALOG_CONFIG = [
    {
        link_show: true,
        label: 'NOME',
        name: 'name',
        type: TypeComponentFieldEnum.INPUT,
        validation: [Validators.required],
        placeholder: 'Nome completo'
    },

    {
        link_show: true,
        label: 'EMAIL',
        name: 'email',
        type: TypeComponentFieldEnum.INPUT_EMAIL,
        validation: [Validators.required, Validators.email],
        placeholder: 'email@exemplo.com'
    },
    {
        link_show: true,
        label: 'DOCUMENTO',
        name: 'document',
        type: TypeComponentFieldEnum.INPUT_CPF_AND_CNPJ,
        validation: [Validators.required],
        placeholder: 'CPF ou CNPJ'
    },
    {
        link_show: true,
        label: 'WHATSAPP',
        name: 'whatsAppNumber',
        type: TypeComponentFieldEnum.INPUT,
        validation: [],
        placeholder: 'WhatsApp'
    },
    {
        link_show: true,
        label: 'TIPO DE ASSINATURA',
        name: 'type',
        type: TypeComponentFieldEnum.SELECT,
        options: [
            'Assinatura',
            ContractSignatureType.CONTRATANTE,
            ContractSignatureType.CONTRATADA,
            ContractSignatureType.TESTEMUNHA,
            ContractSignatureType.INTERVENIENTE,
            ContractSignatureType.FIADOR,
            ContractSignatureType.PARCEIRO,
            ContractSignatureType.CONSULTOR,
            ContractSignatureType.REPRESENTANTE,
            ContractSignatureType.CONTADOR,
            ContractSignatureType.UNIDADE,
            ContractSignatureType.PARCEIRA_REPRESENTADA,
            ContractSignatureType.PARCEIRO_REPRESENTANTE,
            ContractSignatureType.REPRESENTANTE_COMERCIAL,
            ContractSignatureType.PARCERIA_CONSULTORA
        ],
        validation: [Validators.required],
        placeholder: 'Selecione o tipo'
    }
];

export const ADD_TEMPLATE_DIALOG_CONFIG = [
    {
        link_show: true,
        label: 'NOME',
        name: 'name',
        type: TypeComponentFieldEnum.INPUT,
        validation: [Validators.required],
        placeholder: 'Nome do template'
    },
    {
        link_show: true,
        label: 'CONTEÚDO',
        name: 'content',
        type: TypeComponentFieldEnum.INPUT_TEXT_AREA,
        validation: [Validators.required],
        placeholder: 'Conteúdo do template'
    }
];
